import { FC, memo } from "react";

interface CrossUnBoldProps {
  size?: number;
}

const CrossUnBold: FC<CrossUnBoldProps> = ({ size = 18 }) => {
  return (
    <>
      <svg
        width="7"
        height="7"
        viewBox="0 0 7 7"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.234962 0.235741C0.549139 -0.0784356 1.05852 -0.0784354 1.3727 0.235741L3.0793 1.94234L4.7859 0.235742C5.10008 -0.0784354 5.60946 -0.0784362 5.92364 0.235741C6.23781 0.549918 6.23781 1.0593 5.92364 1.37348L4.21703 3.08008L5.92364 4.78668C6.23781 5.10086 6.23781 5.61024 5.92364 5.92442C5.60946 6.23859 5.10008 6.23859 4.7859 5.92441L3.0793 4.21781L1.3727 5.92441C1.05852 6.23859 0.549139 6.23859 0.234962 5.92441C-0.0792153 5.61024 -0.079215 5.10086 0.234962 4.78668L1.94156 3.08008L0.234962 1.37348C-0.079215 1.0593 -0.0792153 0.549918 0.234962 0.235741Z"
          fill="black"
        />
      </svg>
    </>
  );
};

export default memo(CrossUnBold);
